<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div>
          <v-card>
            <v-card-title>
              <v-row>
                <v-col
                  class="primary--text"
                  style="font-size: 1.5em; padding: 20px"
                >{{ $t('nav.translations') }}</v-col>
                <v-spacer></v-spacer>
                <v-col>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-title>

            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :items-per-page="10"
              class="elevation-0"
            >
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: left">{{ props.item.key }}</td>
                  <td style="text-align: center">{{ props.item.lang }}</td>
                  <td style="text-align: left">{{ props.item.value }}</td>
                  <td style="text-align: center">
                    <v-btn
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      @click="deleteItemConfirm(props.item)"
                    >
                      <v-icon small color="primary">mdi-delete</v-icon>
                    </v-btn>&nbsp;
                    <v-btn
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      @click="editItem(props.item)"
                    >
                      <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="dialog" max-width="60%">
              <v-card>
                <v-card-title>
                  <span class="headline mt-5 mb-3">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field
                            v-model="editedItem.key"
                            :disabled="notEditable"
                            :rules="[
                              () => !!editedItem.key || requiredMessage
                            ]"
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('translations.key') }}
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                          <v-text-field
                            v-model="editedItem.lang"
                            type="tel"
                            :rules="[
                              () => !!editedItem.lang || requiredMessage
                            ]"
                            required
                            :maxlength="2"
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('translations.lang') }}
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="7" md="7">
                          <v-text-field
                            v-model="editedItem.value"
                            :rules="[
                              () => !!editedItem.value || requiredMessage
                            ]"
                            required
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('translations.value') }}
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">
                    {{
                    $t('common.cancel')
                    }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!formIsValid"
                    text
                    type="submit"
                    @click="save"
                  >{{ $t('common.save') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-card-actions
              class="table-footer-prepend d-flex pa-4 align-center"
            >
              <v-btn color="primary" dark small left fab @click="createItem()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapMutations, mapGetters, mapActions } from "vuex";

  export default {
    data() {
      return {
        dialog: false,
        requiredMessage: this.$t("common.required"),
        search: "",
        notEditable: true,
        headers: [
          {
            text: this.$t("translations.key"),
            align: "left",
            sortable: true,
            value: "key",
            width: "10%",
          },
          {
            text: this.$t("translations.lang"),
            align: "center",
            value: "lang",
          },
          {
            text: this.$t("translations.value"),
            align: "left",
            value: "value",
          },
          {
            text: this.$t("column.actions"),
            align: "center",
            value: "value",
            width: "15%",
          },
        ],
        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
      };
    },
    computed: {
      ...mapGetters(["m_translation/getTranslations"]),
      formTitle() {
        return this.editedIndex === -1
          ? this.$t("common.new") + " " + this.$t("translations.entity")
          : this.$t("common.edit") + " " + this.$t("translations.entity");
      },

      items() {
        return this["m_translation/getTranslations"];
      },

      formIsValid() {
        return (
          this.editedItem.key && this.editedItem.lang && this.editedItem.value
        );
      },
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this["m_translation/fetchTranslations"]();
    },

    methods: {
      ...mapMutations(["mHideLongLoader"]),
      ...mapActions([
        "m_translation/fetchTranslations",
        "m_translation/updateTranslation",
        "m_translation/createTranslation",
        "m_translation/deleteTranslation",
      ]),

      resetEntity(item) {
        this.editedIndex = item ? this.items.indexOf(item) : -1;
        this.editedItem = Object.assign({}, item || this.defaultItem);
      },

      editItem(item) {
        this.resetEntity(item);
        this.dialog = true;
      },

      deleteItemConfirm(item) {
        var msg = "warning.delete";
        this.$confirm(this.$t(msg) + " entry ?", {
          buttonTrueText: this.$t("common.ok"),
          buttonFalseText: this.$t("common.cancel"),
          color: "warning",
          icon: "warning",
          title: this.$t("common.warning"),
          width: 350,
          property: "$confirm",
        })
          .then((res) => res && this["m_translation/deleteTranslation"](item))
          .then(this.resetEntity);
      },

      createItem() {
        this.resetEntity();
        this.notEditable = false;
        this.dialog = true;
      },

      close() {
        this.$refs.form.resetValidation();
        this.notEditable = true;
        this.dialog = false;
        this.resetEntity();
      },

      save() {
        let data = {
          key: this.editedItem.key,
          lang: this.editedItem.lang,
          value: this.editedItem.value,
        };

        if (~this.editedIndex) {
          data.id = this.editedItem.id;
          this["m_translation/updateTranslation"](data);
        }

        if (!~this.editedIndex) {
          this["m_translation/createTranslation"](data);
        }

        this.close();
      },
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.mHideLongLoader();
      });
    },
  };
</script>
<style scoped>
  .table-footer-prepend {
    margin-top: -58px;
    height: 70px;
  }
</style>